var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7126 26H26.2582V14.7279H23.7126V26ZM14.9861 26H17.5304V6H14.9861V26ZM6.25822 26H8.80379V19.0911H6.25822V26ZM10.8038 26.9089L10.7986 27.0286C10.7485 27.6162 10.3265 28 9.71265 28H5.34936L5.22957 27.9948C4.642 27.9447 4.25822 27.5227 4.25822 26.9089V18.1823C4.25822 17.5685 4.64201 17.1465 5.22957 17.0964L5.34936 17.0911H9.71265C10.3672 17.0911 10.8038 17.5277 10.8038 18.1823V26.9089ZM28.2582 26.9089L28.253 27.0286C28.2029 27.6162 27.7809 28 27.1671 28H22.8038L22.684 27.9948C22.0965 27.9446 21.7126 27.5226 21.7126 26.9089V13.8177C21.7128 13.2042 22.0966 12.7819 22.684 12.7318L22.8038 12.7279H27.1671C27.8215 12.7279 28.258 13.1634 28.2582 13.8177V26.9089ZM19.5304 26.9089C19.5304 27.5632 19.0948 27.9998 18.4405 28H14.0759L13.9561 27.9948C13.4079 27.9477 13.0367 27.577 12.99 27.0286L12.9861 26.9089V5.09115C12.9861 4.43676 13.4216 4.00021 14.0759 4H18.4405C19.0948 4.00021 19.5304 4.43676 19.5304 5.09115V26.9089Z",
    fill: "#4FD1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.d29f383c86f80448869678498d871d4e.svg";
export { ForwardRef as ReactComponent };